import 'rxjs/add/operator/map';
import 'rxjs/add/operator/first';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class Authguard implements CanActivate{

  constructor(private router: Router) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    let browserStorage = localStorage.getItem('browserStorage');
    if (browserStorage != undefined && browserStorage != null) {
      let accessToken = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
      if(accessToken != undefined && accessToken != '') {
        this.router.navigate(['/questionnaires']);
        return Observable.of(false);
      }
      else {
        return Observable.of(true);
      }
    }
    else {
      return Observable.of(true);
    }
}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/authguard-service.ts